// Central query-key registry so the SSE hook can invalidate precisely.
export const qk = {
  me: ["me"] as const,
  selected: (params?: Record<string, string>) => ["selected", params ?? {}] as const,
  selectedOne: (id: string) => ["selected", id] as const,
  preprints: (params?: Record<string, string>) => ["preprints", params ?? {}] as const,
  preprintOne: (id: string) => ["preprint", id] as const,
  referees: (preprintId: string) => ["referees", preprintId] as const,
  proposals: (params?: Record<string, string>) => ["proposals", params ?? {}] as const,
  proposalOne: (id: string) => ["proposal", id] as const,
  qc: (params?: Record<string, string>) => ["qc", params ?? {}] as const,
  operations: (params?: Record<string, string>) => ["operations", params ?? {}] as const,
  reports: ["reports"] as const,
  notifications: ["notifications"] as const,
};

/** Top-level key prefixes the SSE hook invalidates per event type. */
export const PREFIX = {
  preprint: ["preprints", "preprint", "selected", "operations"],
  reviewer: ["proposals", "proposal", "qc", "referees", "preprints", "preprint"],
  coi: ["proposals", "proposal", "qc"],
  notification: ["notifications"],
} as const;
